import { IntlShape } from "react-intl"
import { SalesDetails } from "../../interfaces"
import { dashesToUnderscore } from "helpers/text"

export const getExportDataFileName = (
	metricName: string,
	levelName: string,
	intl: IntlShape
) => {
	const module = intl.formatMessage({
		id:
			"phronesis.transactional.application.commercial.benchmark.tabs.performance",
	})
	const metric = intl.formatMessage(
		{
			id:
				"phronesis.transactional.application.commercial.benchmark.timeline.metricsOptions",
			defaultMessage: dashesToUnderscore(metricName),
		},
		{ metric: dashesToUnderscore(metricName) }
	)
	const tab = intl.formatMessage({
		id: `phronesis.transactional.application.commercial.benchmark.title.first.column.${levelName}`,
		defaultMessage: levelName,
	})
	return `${module}_${metric}_${tab}`
}

interface PerformanceExportData {
	name: string
	currentAmount: number
	previousAmount: number
	growthPercentage: number
	growthValue: number
	walmartGrowthPercentage: number
	barcode?: string
}

export const mapDataToExportFormat = (
	data: SalesDetails[]
): PerformanceExportData[] => {
	const includeBarcode = !data.every((row) => row.barcode === "0")

	return data.map((row) => {
		const exportRow = {
			name: row.name,
			currentAmount: row.currentSales,
			previousAmount: row.previousSales,
			growthPercentage: row.growthPercentage,
			growthValue: row.growthValue,
			walmartGrowthPercentage: row.levelGrowthPercentage,
		} as PerformanceExportData

		if (includeBarcode && row.barcode) {
			exportRow.barcode = row.barcode
		}

		return exportRow
	})
}
